import httpClient from 'utils/httpClient';
import { withPortalScope } from 'utils/portalScope';

const getScopedParams = (params = {}) => withPortalScope(params, { override: true });

export const getSalesHierarchyReport = (params = {}, options = {}) =>
  httpClient.get('/retail-report/sales-hierarchy', {
    params: withPortalScope(params, { includeBusiness: false, includeStore: false, override: true }),
    ...options,
  });

export const getSalesOverviewReport = (params = {}) =>
  httpClient.get('/retail-report/sales-overview', { params: getScopedParams(params) });

export const getRevenueByStoreReport = (params = {}) =>
  httpClient.get('/retail-report/revenue-by-store', { params: getScopedParams(params) });

export const getSalesStaffProductivityReport = (params = {}) =>
  httpClient.get('/retail-report/sales-staff-productivity', { params: getScopedParams(params) });

export const getSalesTransactionReport = (params = {}) =>
  httpClient.get('/retail-report/sales-transactions', { params: getScopedParams(params) });

export const getSalesTransactionExportPage = (params = {}) =>
  httpClient.get('/retail-report/sales-transactions/export', { params: getScopedParams(params) });

export const getEmployeeMonthlyIncomeReport = (params = {}) => {
  return httpClient.get('/retail-report/employee-monthly-income', {
    params: withPortalScope(params, { includeBusiness: false, includeStore: false }),
  });
};

export const getInventorySalesByStoreReport = (params = {}) =>
  httpClient.get('/retail-report/inventory-sales-by-store', { params: getScopedParams(params) });

export const getInventorySalesByStoreExportPage = (params = {}) =>
  httpClient.get('/retail-report/inventory-sales-by-store/export', { params: getScopedParams(params) });

export const updateEmployeeMonthlyIncome = (username, payload = {}) =>
  httpClient.put(`/retail-report/employee-monthly-income/${encodeURIComponent(username)}`, { ...payload });


const getProductSalesScopedParams = (params = {}) =>
  withPortalScope(Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')),
    { includeBusiness: false, includeStore: false, override: true });

const getProductSalesExportParams = (params = {}) => {
  const { page, items_per_page, ...filters } = params;
  return getProductSalesScopedParams(filters);
};

export const getEmployeeProductSalesReport = (params = {}) =>
  httpClient.get('/retail-report/employee-product-sales', { params: getProductSalesScopedParams(params) });

export const getEmployeeProductSalesExport = (params = {}) =>
  httpClient.get('/retail-report/employee-product-sales/export', { params: getProductSalesExportParams(params) });

export const getProductSalesReport = (params = {}) =>
  httpClient.get('/retail-report/product-sales', { params: getProductSalesScopedParams(params) });

export const getProductSalesExport = (params = {}) =>
  httpClient.get('/retail-report/product-sales/export', { params: getProductSalesExportParams(params) });
